import * as React from 'react'
import 'less/controls/progress-bar.less'

const Filler = ({
  className,
  percentage = 0,
}) =>
  <div
    className={`progress-bar ${className}`}
    style={{width: `${percentage}%`}}
  />

export const ProgressBar = (props) =>
  <div className="progress-bar-container">
    <Filler percentage={props.percentage} />
  </div>

export const StackedProgressBar = ({sections}) =>
  <div className="progress-bar-container stacked-progress-bar">
    {sections.map(({percentage, className}) =>
      <Filler key={className} className={className} percentage={percentage} />
    )}
  </div>
